export default {
  title: '贸易条款管理',

  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '条款代码、名称',
    status: '状态',
    statusPlaceholder: '选择状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  table: {
    termsCode: '条款代码',
    termsName: '条款名称',
    status: '状态',
    operation: '操作'
  },

  modal: {
    title: '新增贸易条款',
    confirmText: '确认添加 ({count})',
    selected: '已选择 {count} 个贸易条款，共 {total} 个可选'
  },

  confirm: {
    toggleStatus: '确定要{action}此贸易条款吗？'
  },

  form: {
    addTitle: '新增贸易条款',
    editTitle: '编辑贸易条款',
    termCode: '条款代码',
    termNameCn: '条款名称（中文）',
    termNameEn: '条款名称（英文）',
    description: '描述',
    status: '状态'
  },

  actions: {
    addTradeTerm: '新增贸易条款',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    enable: '启用',
    disable: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  messages: {
    selectToAdd: '请选择要添加的贸易条款',
    selectToEnable: '请选择要启用的贸易条款',
    selectToDisable: '请选择要禁用的贸易条款',
    loadError: '贸易条款数据加载失败，请稍后重试',
    searchError: '贸易条款搜索失败，请稍后重试',
    platformLoadError: '平台贸易条款数据加载失败，请稍后重试',
    associateSuccess: '成功关联 {count} 个贸易条款',
    associateError: '关联贸易条款失败，请稍后重试',
    statusToggleSuccess: '贸易条款状态更新为{status}成功',
    statusToggleError: '状态切换失败，请稍后重试',
    batchEnableSuccess: '已启用 {count} 个贸易条款',
    batchEnableError: '批量启用失败，请稍后重试',
    batchDisableSuccess: '已禁用 {count} 个贸易条款',
    batchDisableError: '批量禁用失败，请稍后重试'
  },

  statusText: {
    enabled: '启用',
    disabled: '禁用'
  }
}
